export enum ExportTypeEnum {
  ZOHO = 'ZOHO',
  DYNAMICS = 'DYNAMICS',
  REVEAL = 'REVEAL',
  CSV = 'CSV',
  SALESFORCE = 'SALESFORCE',
  SALESLOFT = 'SALESLOFT',
  HUBSPOT = 'HUBSPOT',
  OUTREACH = 'OUTREACH',
  MARKETO = 'MARKETO',
  REVEALFORSF = 'REVEALFORSF'
}
